<div class="a">
    <!-- <img class="flag-icon" src="https://flagcdn.com/{{ countryCode?.toLowerCase() }}.svg" /> -->
    <img class="flag-icon" src="https://flagsapi.com/{{ countryCode?.toUpperCase() }}/shiny/64.png" />
</div>